import {useRefraQuery} from '@refra/modules/common/hooks'

interface useUserStorageValueQueryParams {
  keyIdentifier: string
}

export const useUserStorageValueQuery = ({keyIdentifier}: useUserStorageValueQueryParams) => {
  return useRefraQuery({
    queryKey: 'getUserStorageValue',
    params: [{keyIdentifier}],
    throwOnError: false
  })
}
